import {
  ComingSoonAction,
  comingSoonLead,
  useComingSoonContext,
} from "@/home/ComingSoonFor";
import { PlaceholderScreen } from "@/shell/PlaceholderScreen";
import { CartIcon } from "@/ui/icons/CartIcon";

export default function Cart() {
  const context = useComingSoonContext();
  return (
    <PlaceholderScreen
      title="Cart"
      testID="placeholder-cart"
      Icon={CartIcon}
      tile="tileAmber"
      ink="onTileAmber"
      message={comingSoonLead(
        "Your cart and payment will be here.",
        context.who,
      )}
      homeLink
      pushed
    >
      <ComingSoonAction context={context} />
    </PlaceholderScreen>
  );
}
